import { createFileRoute } from '@tanstack/react-router'
import { edyEduOrganizationSearchSchema } from '@/features/edy-edu-organizations/filter-edy-edu-organizations/model/edyEduOrganizationSearch'
import { EdyEduOrganizationsPage } from '@/pages/platform-users/ui/EdyEduOrganizationsPage'

export const Route = createFileRoute('/edu-organizations')({
  validateSearch: edyEduOrganizationSearchSchema,
  component: EdyEduOrganizationsPage,
})
